import SimpleStore from '../utilities/SimpleStore'
import { UTM_SOURCE } from '../constants'

export const getUtmSource = () => {
  const utmSource = SimpleStore.get(UTM_SOURCE) || undefined
  return utmSource && Array.isArray(utmSource)
    ? utmSource[utmSource.length - 1]
    : utmSource
}

export const setUtmSource = queryParams => {
  const utmSource = queryParams.utm_source || undefined
  const savedUtmSource = SimpleStore.get(UTM_SOURCE) || undefined
  if (savedUtmSource && !utmSource) {
    SimpleStore.delete(UTM_SOURCE)
  } else if (utmSource) {
    SimpleStore.set(UTM_SOURCE, utmSource)
  }
}
